import { BaseService } from "../../Base/BaseService";

export interface IPublicMaster {
  id: number;
  userId: number;
  name: string;
  description: string;
  location: string;
  avatarUrl: string;
  isActive: boolean;
  address: string;
  telegram: string;
  hasSchedule: boolean;

  distanceMeters?: number | null;
  distanceText?: string | null;
}

export interface IMasterRating {
  masterId: number;
  averageRating: number;
  reviewsCount: number;
}

export interface IPublicMasterPost {
  id: number;
  masterId: number;
  serviceId: number;
  title: string;
  description: string;
  imageUrl: string;
  isApproved: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface IPublicMasterService {
  id: number;
  masterId: number;
  categoryId: number;
  name: string;
  price: number;
  durationMinutes: number;
  isActive: boolean;
  bookingsCount: number;
}

export interface IPublicMasterReview {
  id: number;
  serviceId?: number;
  userId: number | null;
  authorName: string | null;
  source: string | null;
  rating: number;
  text: string;
  isImported: boolean;
  createdAt: string;
}

export interface IPublicMasterPostsResponse {
  items: IPublicMasterPost[];
  nextCursor: number | null;
  hasMore: boolean;
}

export interface IPublicMasterReviewsResponse {
  reviews: IPublicMasterReview[];
  nextCursor: number | null;
  hasMore: boolean;
}

export class PublicMasterProfileService extends BaseService {
  public static async GetMaster(id: number): Promise<IPublicMaster> {
    return await BaseService.get<IPublicMaster>(this.BaseApiUrl + `/masters/${id}`);
  }

  public static async GetMasterServices(masterId: number): Promise<IPublicMasterService[]> {
    return await BaseService.get<IPublicMasterService[]>(this.BaseApiUrl + `/masters/${masterId}/services`);
  }

  public static async GetRating(id: number): Promise<IMasterRating> {
    return await BaseService.get<IMasterRating>(this.BaseApiUrl + `/masters/${id}/rating`);
  }

  public static async GetMasterPosts(masterId: number, limit: number = 20, cursor?: number | null): Promise<IPublicMasterPostsResponse> {
    let url = this.BaseApiUrl + `/masters/${masterId}/posts?limit=${limit}`;

    if (cursor) {
      url += `&cursor=${cursor}`;
    }

    return await BaseService.get<IPublicMasterPostsResponse>(url);
  }

  public static async GetMasterReviews(masterId: number, limit: number = 20, cursor?: number | null): Promise<IPublicMasterReviewsResponse> {
    let url = this.BaseApiUrl + `/masters/${masterId}/reviews?limit=${limit}`;

    if (cursor) {
      url += `&cursor=${cursor}`;
    }

    return await BaseService.get<IPublicMasterReviewsResponse>(url);
  }

  public static async GetServiceReviews(serviceId: number, limit: number = 20, cursor?: number | null): Promise<IPublicMasterReviewsResponse> {
    let url = this.BaseApiUrl + `/services/${serviceId}/reviews?limit=${limit}`;

    if (cursor) {
      url += `&cursor=${cursor}`;
    }

    return await BaseService.get<IPublicMasterReviewsResponse>(url);
  }
}
